import React from 'react';
import PropTypes from 'prop-types';
import 'src/components/EmptyListing.scss';

import FileSearch from '@mdi/svg/svg/file-search.svg';


const Placeholder = ({ header, copy }) => (
  <React.Fragment>
    <div styleName="empty-listing__icon">
      <FileSearch viewBox="0 0 24 24" />
    </div>

    <h3 styleName="empty-listing__header">
      {header}
    </h3>

    <p styleName="empty-listing__copy">
      {copy}
    </p>
  </React.Fragment>
);

const EmptyListing = ({
  header, copy, link
}) => (
  <React.Fragment>
    {
      link
      && (
      <a href={ link } styleName="empty-listing empty-listing--interactive" title={ header }>
        <Placeholder { ...{ header, copy } } />
      </a>
      )
    }

    {
      !link
      && (
      <div styleName="empty-listing">
        <Placeholder { ...{ header, copy } } />
      </div>
      )
    }
  </React.Fragment>
);


Placeholder.propTypes = {
  copy: PropTypes.node.isRequired,
  header: PropTypes.string.isRequired
};

EmptyListing.propTypes = {
  copy: PropTypes.node.isRequired,
  header: PropTypes.string.isRequired,
  link: PropTypes.string
};

EmptyListing.defaultProps = {
  link: ''
};


export default EmptyListing;
